import React from 'react';
import dailyFocusDial from '../assets/screenshots/daily-focus-dial.png';
import chooseYourMood from '../assets/screenshots/choose-your-mood.png';
import dialItIn from '../assets/screenshots/dial-it-in.png';
import stayInFlow from '../assets/screenshots/stay-in-flow.png';
import focusLedger from '../assets/screenshots/focus-ledger.png';
import { AppleLogo, GoogleGLogo } from './AppIcons';

const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/hustle-dial/id6748039370';
const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.hustledial.hustledial';

const screenshots = [
  {
    label: 'Your daily focus dial',
    title: 'Track every minute.',
    copy: 'The home screen keeps the daily target, streak, sessions, and weekly total close without turning focus into noise.',
    image: dailyFocusDial,
  },
  {
    label: 'Set your intention',
    title: 'Choose your mood.',
    copy: 'A session starts with tone: calm work, admin chores, beast mode, brainstorm, or a custom vibe.',
    image: chooseYourMood,
  },
  {
    label: 'You set the pace',
    title: 'Dial it in.',
    copy: 'Quick presets and the physical dial make time selection feel intentional before the session begins.',
    image: dialItIn,
  },
  {
    label: 'Deep work mode',
    title: 'Stay in the flow.',
    copy: 'The live session screen strips the interface down to remaining time, momentum, and a single focused prompt.',
    image: stayInFlow,
  },
  {
    label: 'Every session logged',
    title: 'Your focus ledger.',
    copy: 'Completed, partial, and stopped sessions stay visible so the habit has a real record.',
    image: focusLedger,
  },
];

const ScreenshotPanel = ({ item }) => (
  <article className="hd-shot-card">
    <div className="grid gap-8 lg:items-center lg:grid-cols-[0.82fr_1fr]">
      <div className="order-2 lg:order-1">
        <p className="hd-kicker text-lime">{item.label}</p>
        <h3 className="hd-display text-4xl md:text-5xl text-bone mt-4 leading-none">
          {item.title}
        </h3>
        <p className="text-hdMuted leading-relaxed mt-5 max-w-md">
          {item.copy}
        </p>
      </div>

      <div className="order-1 lg:order-2">
        <div className="hd-phone-poster">
          <img src={item.image} alt={item.title} className="h-full w-full object-cover" />
        </div>
      </div>
    </div>
  </article>
);

const ScreenshotsCarousel = () => {
  return (
    <section id="features" className="hd-section relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <p className="hd-kicker text-lime">Core flow / mobile</p>
          <h2 className="hd-display text-5xl md:text-7xl text-bone leading-[0.95] mt-5">
            The app finally feels
            <span className="block text-lime italic">as focused as the habit.</span>
          </h2>
          <p className="text-hdMuted text-lg md:text-xl leading-relaxed mt-7">
            These screens bring the new product language into the landing page:
            warm light surfaces, obsidian contrast, sage actions, and a stronger sense of pace.
          </p>
        </div>

        <div className="mt-16 grid gap-5 lg:grid-cols-2">
          {screenshots.map((item) => (
            <ScreenshotPanel key={item.title} item={item} />
          ))}
        </div>

        <div className="mt-16 flex flex-col items-center gap-5 text-center">
          <p className="hd-kicker text-lime">Download the app</p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={IOS_APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hd-store-badge"
              aria-label="Download on the iOS App Store"
            >
              <span className="hd-store-icon" aria-hidden="true">
                <AppleLogo className="w-5 h-5" />
              </span>
              <span>iOS App Store</span>
            </a>
            <a
              href={ANDROID_PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hd-store-badge"
              aria-label="Download Hustle Dial on Google Play"
            >
              <span className="hd-store-icon hd-store-icon-google" aria-hidden="true">
                <GoogleGLogo className="w-5 h-5" />
              </span>
              <span>Google Play</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScreenshotsCarousel;
